'use strict';
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
      global.localePolicy = factory()
}(this, function () {
  var LocalePolicyOption = {
    // predefined locale poliy at client side.
    // These values are used as default format value for each regional format.
    // The default timezones are not used in NDSE yet.
    predefinedPolicy: [
      {
        cultureName: 'de',
        effectiveTimeZone: 'tz_93_west_europe',
        effectiveCurrencyPositiveFormat: 'leading_1_period_234_period_567_comma_89_space_csym',
        effectiveCurrencyNegativeFormat: 'minus_1_period_234_period_567_comma_89_space_csym',
        effectiveCurrencyCode: 'eur'
      },
      {
        cultureName: 'en',
        effectiveTimeZone: 'tz_66_pacific',
        effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyNegativeFormat: 'opar_csym_1_comma_234_comma_567_period_89_cpar',
        effectiveCurrencyCode: 'usd'
      },
      {
        cultureName: 'en_au',
        effectiveTimeZone: 'tz_28_east_australia',
        effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyCode: 'aud'
      },
      {
        cultureName: 'en_us',
        effectiveTimeZone: 'tz_66_pacific',
        effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyNegativeFormat: 'opar_csym_1_comma_234_comma_567_period_89_cpar',
        effectiveCurrencyCode: 'usd'
      },
      {
        cultureName: 'en_gb',
        effectiveTimeZone: 'tz_37_gmt',
        effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyCode: 'gbp'
      },
      {
        cultureName: 'es',
        effectiveTimeZone: 'tz_70_romance',
        effectiveCurrencyPositiveFormat: 'leading_1_period_234_period_567_comma_89_space_csym',
        effectiveCurrencyNegativeFormat: 'minus_1_period_234_period_567_comma_89_space_csym',
        effectiveCurrencyCode: 'eur'
      },
      {
        cultureName: 'es_mx',
        effectiveTimeZone: 'tz_24_central_mexico',
        effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyCode: 'mxn'
      },
      {
        cultureName: 'fr',
        effectiveTimeZone: 'tz_70_romance',
        effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
        effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
        effectiveCurrencyCode: 'eur'
      },
      {
        cultureName: 'fr_ca',
        effectiveTimeZone: 'tz_13_canada_central',
        effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
        effectiveCurrencyNegativeFormat: 'opar_1_space_234_space_567_comma_89_space_csym_cpar',
        effectiveCurrencyCode: 'cad'
      },
      {
        cultureName: 'it',
        effectiveTimeZone: 'tz_93_west_europe',
        effectiveCurrencyPositiveFormat: 'csym_space_1_period_234_period_567_comma_89',
        effectiveCurrencyNegativeFormat: 'minus_csym_space_1_period_234_period_567_comma_89',
        effectiveCurrencyCode: 'eur'
      },
      {
        cultureName: 'ja',
        effectiveTimeZone: 'tz_83_tokyo',
        effectiveNameFormat: 'last_first_cjk',
        effectiveInitialFormat: 'last2_cjk',
        effectiveAddressFormat: 'ja_jp',
        effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89', // 'csym_1_comma_234_comma_567',
        effectiveCurrencyNegativeFormat: 'csym_minus_12_comma_34_comma_567_period_89', // minus_csym_1_comma_234_comma_567',
        effectiveCurrencyCode: 'jpy'
      },
      {
        cultureName: 'ko',
        effectiveTimeZone: 'tz_48_korea',
        effectiveNameFormat: 'last_first_cjk',
        effectiveInitialFormat: 'last2_cjk',
        effectiveAddressFormat: 'ja_jp',
        effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89', // 'csym_1_comma_234_comma_567',
        effectiveCurrencyNegativeFormat: 'csym_minus_12_comma_34_comma_567_period_89', // 'minus_csym_1_comma_234_comma_567',
        effectiveCurrencyCode: 'krw'
      },
      {
        cultureName: 'nl',
        effectiveTimeZone: 'tz_93_west_europe',
        effectiveCurrencyPositiveFormat: 'csym_space_1_period_234_period_567_comma_89',
        effectiveCurrencyNegativeFormat: 'csym_space_minus_1_period_234_period_567_comma_89',
        effectiveCurrencyCode: 'eur'
      },
      {
        cultureName: 'pt',
        effectiveTimeZone: 'tz_37_gmt',
        effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
        effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
        effectiveCurrencyCode: 'eur'
      },
      {
        cultureName: 'pt_br',
        effectiveTimeZone: 'tz_30_east_south_america',
        effectiveCurrencyPositiveFormat: 'csym_space_1_period_234_period_567_comma_89',
        effectiveCurrencyNegativeFormat: 'minus_csym_space_1_period_234_period_567_comma_89',
        effectiveCurrencyCode: 'brl'
      },
      {
        cultureName: 'ru',
        effectiveTimeZone: 'tz_71_russian',
        effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
        effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
        effectiveCurrencyCode: 'rub'
      },
      {
        cultureName: 'zh_cn',
        effectiveTimeZone: 'tz_25_china',
        effectiveNameFormat: 'last_first_cjk',
        effectiveInitialFormat: 'last2_cjk',
        effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyNegativeFormat: 'csym_minus_12_comma_34_comma_567_period_89',
        effectiveCurrencyCode: 'cny'
      },
      {
        cultureName: 'zh_tw',
        effectiveTimeZone: 'tz_81_taipei',
        effectiveNameFormat: 'last_first_cjk',
        effectiveInitialFormat: 'last2_cjk',
        effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
        effectiveCurrencyCode: 'twd'
      },
    ],
    baseLocalePolicy: {
      effectiveNameFormat: 'first_middle_last',
      effectiveInitialFormat: 'first1last1',
      effectiveAddressFormat: 'en_us',
      effectiveCalendarType: 'gregorian',
      effectiveDateFormat: 'default',
      effectiveTimeZone: 'tz_37_gmt',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'usd'
    },
    predefinedPolicyV2: [ {
      cultureName: 'ar',
      effectiveTimeZone: 'tz_05_arabic',
      effectiveCurrencyPositiveFormat: 'csym_space_1234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'ars'
    }, {
      cultureName: 'bg_bg',
      effectiveTimeZone: 'tz_35_fli',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'bgn'
    }, {
      cultureName: 'cs_cz',
      effectiveTimeZone: 'tz_93_west_europe',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'czk'
    }, {
      cultureName: 'da_dk',
      effectiveTimeZone: 'tz_70_romance',
      effectiveCurrencyPositiveFormat: 'csym_space_1_period_234_period_567_comma_89',
      effectiveCurrencyNegativeFormat: 'csym_space_minus_1_period_234_period_567_comma_89',
      effectiveCurrencyCode: 'dkk'
    }, {
      cultureName: 'de_de',
      effectiveTimeZone: 'tz_93_west_europe',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'el_gr',
      effectiveTimeZone: 'tz_40_gtb',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'en_au',
      effectiveTimeZone: 'tz_28_east_australia',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'aud'
    }, {
      cultureName: 'en_gb',
      effectiveTimeZone: 'tz_37_gmt',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'gbp'
    }, {
      cultureName: 'en_us',
      effectiveTimeZone: 'tz_66_pacific',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'opar_csym_1_comma_234_comma_567_period_89_cpar',
      effectiveCurrencyCode: 'usd'
    }, {
      cultureName: 'es_es',
      effectiveTimeZone: 'tz_70_romance',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'es_mx',
      effectiveTimeZone: 'tz_24_central_mexico',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'mxn'
    }, {
      cultureName: 'et_ee',
      effectiveTimeZone: 'tz_35_fli',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_period_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_period_89_space_csym',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'fa_ir',
      effectiveTimeZone: 'tz_43_iran',
      effectiveCurrencyPositiveFormat: 'csym_space_12_comma_34_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'irr'
    }, {
      cultureName: 'fi_fi',
      effectiveTimeZone: 'tz_35_fli',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'fr_ca',
      effectiveTimeZone: 'tz_13_canada_central',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'opar_1_space_234_space_567_comma_89_space_csym_cpar',
      effectiveCurrencyCode: 'cad'
    }, {
      cultureName: 'fr_fr',
      effectiveTimeZone: 'tz_70_romance',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'he_il',
      effectiveTimeZone: 'tz_44_israel',
      effectiveCurrencyPositiveFormat: 'csym_space_1234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'csym_minus_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'ils'
    }, {
      cultureName: 'hi_in',
      effectiveTimeZone: 'tz_42_india',
      effectiveCurrencyPositiveFormat: 'csym_space_12_comma_34_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'csym_space_minus_12_comma_34_comma_567_period_89',
      effectiveCurrencyCode: 'inr'
    }, {
      cultureName: 'hr_hr',
      effectiveTimeZone: 'tz_21_central_european',
      effectiveCurrencyCode: 'hrk'
    }, {
      cultureName: 'hu_hu',
      effectiveTimeZone: 'tz_93_west_europe',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'huf'
    }, {
      cultureName: 'hy_am',
      effectiveTimeZone: 'tz_15_caucasus',
      effectiveCurrencyPositiveFormat: 'leading_1_comma_234_comma_567_period_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_comma_234_comma_567_period_89_space_csym',
      effectiveCurrencyCode: 'amd'
    }, {
      cultureName: 'id_id',
      effectiveTimeZone: 'tz_76_se_asia',
      effectiveCurrencyPositiveFormat: 'csym_1_period_234_period_567',
      effectiveCurrencyNegativeFormat: 'opar_csym_1_period_234_period_567_cpar',
      effectiveCurrencyCode: 'idr'
    }, {
      cultureName: 'it_it',
      effectiveTimeZone: 'tz_93_west_europe',
      effectiveCurrencyPositiveFormat: 'csym_space_1_period_234_period_567_comma_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_space_1_period_234_period_567_comma_89',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'ja_jp',
      effectiveNameFormat: 'last_first_cjk',
      effectiveInitialFormat: 'last2_cjk',
      effectiveAddressFormat: 'ja_jp',
      effectiveTimeZone: 'tz_83_tokyo',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567',
      effectiveCurrencyCode: 'jpy'
    }, {
      cultureName: 'ko_kr',
      effectiveNameFormat: 'last_first_cjk',
      effectiveInitialFormat: 'last2_cjk',
      effectiveAddressFormat: 'ja_jp',
      effectiveTimeZone: 'tz_48_korea',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567',
      effectiveCurrencyCode: 'krw'
    }, {
      cultureName: 'lt_lt',
      effectiveTimeZone: 'tz_35_fli',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'lv_lv',
      effectiveTimeZone: 'tz_35_fli',
      effectiveCurrencyPositiveFormat: 'csym_space_1_space_234_space_567_comma_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_space_1_space_234_space_567_comma_89',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'ms_my',
      effectiveTimeZone: 'tz_77_singapore',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567',
      effectiveCurrencyNegativeFormat: 'opar_csym_1_comma_234_comma_567_cpar',
      effectiveCurrencyCode: 'myr'
    }, {
      cultureName: 'nb_no',
      effectiveTimeZone: 'tz_93_west_europe',
      effectiveCurrencyPositiveFormat: 'csym_space_1_space_234_space_567_comma_89',
      effectiveCurrencyNegativeFormat: 'csym_space_minus_1_space_234_space_567_comma_89',
      effectiveCurrencyCode: 'nok'
    }, {
      cultureName: 'nl_nl',
      effectiveTimeZone: 'tz_93_west_europe',
      effectiveCurrencyPositiveFormat: 'csym_space_1_period_234_period_567_comma_89',
      effectiveCurrencyNegativeFormat: 'csym_space_minus_1_period_234_period_567_comma_89',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'pl_pl',
      effectiveTimeZone: 'tz_21_central_european',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'pln'
    }, {
      cultureName: 'pt_br',
      effectiveTimeZone: 'tz_30_east_south_america',
      effectiveCurrencyPositiveFormat: 'csym_space_1_period_234_period_567_comma_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_space_1_period_234_period_567_comma_89',
      effectiveCurrencyCode: 'brl'
    }, {
      cultureName: 'pt_pt',
      effectiveTimeZone: 'tz_37_gmt',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'ro_ro',
      effectiveTimeZone: 'tz_40_gtb',
      effectiveCurrencyCode: 'ron'
    }, {
      cultureName: 'ru_ru',
      effectiveTimeZone: 'tz_71_russian',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'rub'
    }, {
      cultureName: 'sk_sk',
      effectiveTimeZone: 'tz_93_west_europe',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_space_csym',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'sl_si',
      effectiveTimeZone: 'tz_93_west_europe',
      effectiveCurrencyCode: 'eur'
    }, {
      cultureName: 'sr',
      effectiveTimeZone: 'tz_72_sa_eastern',
      effectiveCurrencyCode: 'rsd'
    }, {
      cultureName: 'sv_se',
      effectiveTimeZone: 'tz_93_west_europe',
      effectiveCurrencyCode: 'sek'
    }, {
      cultureName: 'th_th',
      effectiveTimeZone: 'tz_76_se_asia',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'thb'
    }, {
      cultureName: 'tr_tr',
      effectiveTimeZone: 'tz_85_turkey',
      effectiveCurrencyCode: 'try'
    }, {
      cultureName: 'uk_ua',
      effectiveTimeZone: 'tz_35_fli',
      effectiveCurrencyPositiveFormat: 'leading_1_space_234_space_567_comma_89_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_space_234_space_567_comma_89_csym',
      effectiveCurrencyCode: 'uah'
    }, {
      cultureName: 'vi_vn',
      effectiveTimeZone: 'tz_76_se_asia',
      effectiveCurrencyCode: 'vnd'
    }, {
      cultureName: 'zh_cn',
      effectiveNameFormat: 'last_first_cjk',
      effectiveInitialFormat: 'last2_cjk',
      effectiveAddressFormat: 'zh_cn_tw',
      effectiveTimeZone: 'tz_25_china',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'csym_minus_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'cny'
    }, {
      cultureName: 'zh_tw',
      effectiveNameFormat: 'last_first_cjk',
      effectiveInitialFormat: 'last2_cjk',
      effectiveAddressFormat: 'zh_cn_tw',
      effectiveTimeZone: 'tz_81_taipei',
      effectiveCurrencyPositiveFormat: 'csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyNegativeFormat: 'minus_csym_1_comma_234_comma_567_period_89',
      effectiveCurrencyCode: 'twd'
    }
    ],
    baseLocalePolicyV2: {
      effectiveNameFormat: 'full',
      effectiveInitialFormat: 'first1last1',
      effectiveAddressFormat: 'en_us',
      effectiveCalendarType: 'gregorian',
      effectiveDateFormat: 'default',
      effectiveTimeZone: 'tz_37_gmt',
      effectiveCurrencyPositiveFormat: 'leading_1_period_234_period_567_comma_89_space_csym',
      effectiveCurrencyNegativeFormat: 'minus_1_period_234_period_567_comma_89_space_csym',
      effectiveCurrencyCode: 'usd'
    },
    initialFormatters: {
      first2: {
        firstN: 2,
        lastN: 0,
        cjk_validate: false
      },
      last2: {
        firstN: 0,
        lastN: 2,
        cjk_validate: false
      },
      first1last1: {
        firstN: 1,
        lastN: 1,
        cjk_validate: false
      },
      last2_cjk: {
        firstN: 0,
        lastN: 2,
        cjk_validate: true
      }
    },
    nameFormatters: {
      full: {
        numN: 5,
        separator: ' ',
        lastfirst: false,
        cjk_validate: false
      },
      first_middle_last: {
        numN: 3,
        separator: ' ',
        lastfirst: false,
        cjk_validate: false
      },
      lastfirst: {
        numN: 1,
        separator: '',
        lastfirst: true,
        cjk_validate: false
      },
      last_first: {
        numN: 2,
        separator: ' ',
        lastfirst: true,
        cjk_validate: false
      },
      lastfirst_cjk: {
        numN: 1,
        separator: '',
        lastfirst: true,
        cjk_validate: true
      },
      last_first_cjk: {
        numN: 2,
        separator: ' ',
        lastfirst: true,
        cjk_validate: true
      }
    },
    timeZones: [
      {
        // "index": 1,
        'display': '(UTC+04:30) Kabul',
        'utcOffset': '4.5'
      }, {
        // "index": 2,
        'display': '(UTC-09:00) Alaska',
        'utcOffset': '-9'
      }, {
        // "index": 3,
        'display': '(UTC+03:00) Kuwait, Riyadh',
        'utcOffset': '3'
      }, {
        // "index": 4,
        'display': '(UTC+04:00) Abu Dhabi, Muscat',
        'utcOffset': '4'
      }, {
        // "index": 5,
        'display': '(UTC+03:00) Baghdad',
        'utcOffset': '3'
      }, {
        // "index": 6,
        'display': '(UTC-03:00) City of Buenos Aires',
        'utcOffset': '-3'
      }, {
        // "index": 7,
        'display': '(UTC-04:00) Atlantic Time (Canada)',
        'utcOffset': '-4'
      }, {
        // "index": 8,
        'display': '(UTC+09:30) Darwin',
        'utcOffset': '9.5'
      }, {
        // "index": 9,
        'display': '(UTC+10:00) Canberra, Melbourne, Sydney',
        'utcOffset': '10'
      }, {
        // "index": 10,
        'display': '(UTC+04:00) Baku',
        'utcOffset': '4'
      }, {
        // "index": 11,
        'display': '(UTC-01:00) Azores',
        'utcOffset': '-1'
      }, {
        // "index": 12,
        'display': '(UTC+06:00) Dhaka',
        'utcOffset': '6'
      }, {
        // "index": 13,
        'display': '(UTC-06:00) Saskatchewan',
        'utcOffset': '-6'
      }, {
        // "index": 14,
        'display': '(UTC-01:00) Cabo Verde Is.',
        'utcOffset': '-1'
      }, {
        // "index": 15,
        'display': '(UTC+04:00) Yerevan',
        'utcOffset': '4'
      }, {
        // "index": 16,
        'display': '(UTC+09:30) Adelaide',
        'utcOffset': '9.5'
      }, {
        // "index": 17,
        'display': '(UTC-06:00) Central America',
        'utcOffset': '-6'
      }, {
        // "index": 18,
        'display': '(UTC+06:00) Astana',
        'utcOffset': '6'
      }, {
        // "index": 19,
        'display': '(UTC-04:00) Cuiaba',
        'utcOffset': '-4'
      }, {
        // "index": 20,
        'display': '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
        'utcOffset': '1'
      }, {
        // "index": 21,
        'display': '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
        'utcOffset': '1'
      }, {
        // "index": 22,
        'display': '(UTC+11:00) Solomon Is., New Caledonia',
        'utcOffset': '11'
      }, {
        // "index": 23,
        'display': '(UTC-06:00) Central Time (US & Canada)',
        'utcOffset': '-6'
      }, {
        // "index": 24,
        'display': '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
        'utcOffset': '-6'
      }, {
        // "index": 25,
        'display': '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
        'utcOffset': '8'
      }, {
        // "index": 26,
        'display': '(UTC-12:00) International Date Line West',
        'utcOffset': '-12'
      }, {
        // "index": 27,
        'display': '(UTC+03:00) Nairobi',
        'utcOffset': '3'
      }, {
        // "index": 28,
        'display': '(UTC+10:00) Brisbane',
        'utcOffset': '10'
      }, {
        // "index": 29,
        'display': '(UTC+03:00) Minsk',
        'utcOffset': '3'
      }, {
        // "index": 30,
        'display': '(UTC-03:00) Brasilia',
        'utcOffset': '-3'
      }, {
        // "index": 31,
        'display': '(UTC-05:00) Eastern Time (US & Canada)',
        'utcOffset': '-5'
      }, {
        // "index": 32,
        'display': '(UTC+02:00) Cairo',
        'utcOffset': '2'
      }, {
        // "index": 33,
        'display': '(UTC+05:00) Ekaterinburg',
        'utcOffset': '5'
      }, {
        // "index": 34,
        'display': '(UTC+12:00) Fiji',
        'utcOffset': '12'
      }, {
        // "index": 35,
        'display': '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
        'utcOffset': '2'
      }, {
        // "index": 36,
        'display': '(UTC+04:00) Tbilisi',
        'utcOffset': '4'
      }, {
        // "index": 37,
        'display': '(UTC) Dublin, Edinburgh, Lisbon, London',
        'utcOffset': '0'
      }, {
        // "index": 38,
        'display': '(UTC-03:00) Greenland',
        'utcOffset': '-3'
      }, {
        // "index": 39,
        'display': '(UTC) Monrovia, Reykjavik',
        'utcOffset': '0'
      }, {
        // "index": 40,
        'display': '(UTC+02:00) Athens, Bucharest',
        'utcOffset': '2'
      }, {
        // "index": 41,
        'display': '(UTC-10:00) Hawaii',
        'utcOffset': '-10'
      }, {
        // "index": 42,
        'display': '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
        'utcOffset': '5.5'
      }, {
        // "index": 43,
        'display': '(UTC+03:30) Tehran',
        'utcOffset': '3.5'
      }, {
        // "index": 44,
        'display': '(UTC+02:00) Jerusalem',
        'utcOffset': '2'
      }, {
        // "index": 45,
        'display': '(UTC+02:00) Amman',
        'utcOffset': '2'
      }, {
        // "index": 46,
        'display': '(UTC+02:00) Kaliningrad',
        'utcOffset': '2'
      }, {
        // "index": 47,
        'display': '(UTC+12:00) Petropavlovsk-Kamchatsky',
        'utcOffset': '12'
      }, {
        // "index": 48,
        'display': '(UTC+09:00) Seoul',
        'utcOffset': '9'
      }, {
        // "index": 49,
        'display': '(UTC+11:00) Magadan',
        'utcOffset': '11'
      }, {
        // "index": 50,
        'display': '(UTC+04:00) Port Louis',
        'utcOffset': '4'
      }, {
        // "index": 51,
        'display': '(UTC-02:00) Mid-Atlantic',
        'utcOffset': '-2'
      }, {
        // "index": 52,
        'display': '(UTC+02:00) Beirut',
        'utcOffset': '2'
      }, {
        // "index": 53,
        'display': '(UTC-03:00) Montevideo',
        'utcOffset': '-3'
      }, {
        // "index": 54,
        'display': '(UTC) Casablanca',
        'utcOffset': '0'
      }, {
        // "index": 55,
        'display': '(UTC-07:00) Mountain Time (US & Canada)',
        'utcOffset': '-7'
      }, {
        // "index": 56,
        'display': '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
        'utcOffset': '-7'
      }, {
        // "index": 57,
        'display': '(UTC+06:30) Yangon (Rangoon)',
        'utcOffset': '6.5'
      }, {
        // "index": 58,
        'display': '(UTC+07:00) Novosibirsk',
        'utcOffset': '7'
      }, {
        // "index": 59,
        'display': '(UTC+01:00) Windhoek',
        'utcOffset': '1'
      }, {
        // "index": 60,
        'display': '(UTC+05:45) Kathmandu',
        'utcOffset': '5.75'
      }, {
        // "index": 61,
        'display': '(UTC+12:00) Auckland, Wellington',
        'utcOffset': '12'
      }, {
        // "index": 62,
        'display': '(UTC-03:30) Newfoundland',
        'utcOffset': '-3.5'
      }, {
        // "index": 63,
        'display': '(UTC+08:00) Irkutsk',
        'utcOffset': '8'
      }, {
        // "index": 64,
        'display': '(UTC+07:00) Krasnoyarsk',
        'utcOffset': '7'
      }, {
        // "index": 65,
        'display': '(UTC-04:00) Santiago',
        'utcOffset': '-4'
      }, {
        // "index": 66,
        'display': '(UTC-08:00) Pacific Time (US & Canada)',
        'utcOffset': '-8'
      }, {
        // "index": 67,
        'display': '(UTC-08:00) Baja California',
        'utcOffset': '-8'
      }, {
        // "index": 68,
        'display': '(UTC+05:00) Islamabad, Karachi',
        'utcOffset': '5'
      }, {
        // "index": 69,
        'display': '(UTC-04:00) Asuncion',
        'utcOffset': '-4'
      }, {
        // "index": 70,
        'display': '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
        'utcOffset': '1'
      }, {
        // "index": 71,
        'display': '(UTC+03:00) Moscow, St. Petersburg, Volgograd',
        'utcOffset': '3'
      }, {
        // "index": 72,
        'display': '(UTC-03:00) Cayenne, Fortaleza',
        'utcOffset': '-3'
      }, {
        // "index": 73,
        'display': '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
        'utcOffset': '-5'
      }, {
        // "index": 74,
        'display': '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
        'utcOffset': '-4'
      }, {
        // "index": 75,
        'display': '(UTC+13:00) Samoa',
        'utcOffset': '13'
      }, {
        // "index": 76,
        'display': '(UTC+07:00) Bangkok, Hanoi, Jakarta',
        'utcOffset': '7'
      }, {
        // "index": 77,
        'display': '(UTC+08:00) Kuala Lumpur, Singapore',
        'utcOffset': '8'
      }, {
        // "index": 78,
        'display': '(UTC+02:00) Harare, Pretoria',
        'utcOffset': '2'
      }, {
        // "index": 79,
        'display': '(UTC+05:30) Sri Jayawardenepura',
        'utcOffset': '5.5'
      }, {
        // "index": 80,
        'display': '(UTC+02:00) Damascus',
        'utcOffset': '2'
      }, {
        // "index": 81,
        'display': '(UTC+08:00) Taipei',
        'utcOffset': '8'
      }, {
        // "index": 82,
        'display': '(UTC+10:00) Hobart',
        'utcOffset': '10'
      }, {
        // "index": 83,
        'display': '(UTC+09:00) Osaka, Sapporo, Tokyo',
        'utcOffset': '9'
      }, {
        // "index": 84,
        'display': '(UTC+13:00) Nuku\'alofa',
        'utcOffset': '13'
      }, {
        // "index": 85,
        'display': '(UTC+03:00) Istanbul',
        'utcOffset': '3'
      }, {
        // "index": 86,
        'display': '(UTC+08:00) Ulaanbaatar',
        'utcOffset': '8'
      }, {
        // "index": 87,
        'display': '(UTC-05:00) Indiana (East)',
        'utcOffset': '-5'
      }, {
        // "index": 88,
        'display': '(UTC-07:00) Arizona',
        'utcOffset': '-7'
      }, {
        // "index": 89,
        'display': '(UTC-04:00) Caracas',
        'utcOffset': '-4'
      }, {
        // "index": 90,
        'display': '(UTC+10:00) Vladivostok',
        'utcOffset': '10'
      }, {
        // "index": 91,
        'display': '(UTC+08:00) Perth',
        'utcOffset': '8'
      }, {
        // "index": 92,
        'display': '(UTC+01:00) West Central Africa',
        'utcOffset': '1'
      }, {
        // "index": 93,
        'display': '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
        'utcOffset': '1'
      }, {
        // "index": 94,
        'display': '(UTC+05:00) Ashgabat, Tashkent',
        'utcOffset': '5'
      }, {
        // "index": 95,
        'display': '(UTC+10:00) Guam, Port Moresby',
        'utcOffset': '10'
      }, {
        // "index": 96,
        'display': '(UTC+09:00) Yakutsk',
        'utcOffset': '9'
      }
    ],
    timeFormat: {
      none: '',
      hhmm: 'HH:mm',
      hmm: 'h:mm',
      hhmmss: 'HH:mm:ss',
      hmmss: 'h:mm:ss',
      hhmmtt: 'HH:mm tt',
      hmmtt: 'h:mm tt',
      hhmmsstt: 'HH:mm:ss tt',
      hmmsstt: 'h:mm:ss tt',
      custom: 'H:mm'
    },
    dateFormat: {
      'default': {
        _: 'M/d/yyyy',
        'de': 'dd.MM.yyyy',
        'es': 'dd/MM/yyyy',
        'ru': 'dd.MM.yyyy',
        'fr': 'dd/MM/yyyy',
        'it': 'dd/MM/yyyy',
        'nl': 'dd/MM/yyyy',
        'pl': 'dd.MM.yyyy',
        'pt_br': 'dd/MM/yyyy',
        'pt': 'dd/MM/yyyy',
        'zh_cn': 'yyyy/M/d',
        'zh_tw': 'yyyy/M/d',
        'ja': 'yyyy/M/d',
        'ko': 'yyyy/M/d'
      },
      mm_dd_yyyy: {
        _: 'MM-dd-yyyy'
      },
      mmddyyyy: {
        _: 'MM/dd/yyyy'
      },
      mmddyy: {
        _: 'MM/dd/yy'
      },
      mdyyyy: {
        _: 'M/d/yyyy',
        'de': 'dd.MM.yyyy',
        'es': 'dd/MM/yyyy',
        'ru': 'dd.MM.yyyy',
        'fr': 'dd/MM/yyyy',
        'it': 'dd/MM/yyyy',
        'nl': 'dd/MM/yyyy',
        'pl': 'dd.MM.yyyy',
        'pt_br': 'dd/MM/yyyy',
        'pt': 'dd/MM/yyyy',
        'zh_cn': 'yyyy/M/d',
        'zh_tw': 'yyyy/M/d',
        'ja': 'yyyy/M/d',
        'ko': 'yyyy/M/d'
      },
      mmm_dd_yyyy: {
        _: 'MMM-dd-yyyy',
        'zh_cn': 'M-dd-yyyy',
        'zh_tw': 'M-dd-yyyy',
        'ja': 'M-dd-yyyy',
        'ko': 'M-dd-yyyy'
      },
      mmmd_yyyy: {
        _: 'MMM d, yyyy',
        'zh_cn': 'M d, yyyy',
        'zh_tw': 'M d, yyyy',
        'ja': 'M d, yyyy',
        'ko': 'M d, yyyy'
      },
      mmmmd_yyyy: {
        _: 'MMMM d, yyyy',
        'zh_cn': 'yyyy年M月d日',
        'zh_tw': 'yyyy年M月d日',
        'ja': 'yyyy年M月d日',
        'ko': 'yyyy년M월d일'
      },
      dmyyyy: {
        _: 'd/M/yyyy'
      },
      d_m_yyyy: {
        _: 'd-M-yyyy'
      },
      dd_mm_yy: {
        _: 'dd-MM-yy'
      },
      dd_mm_yyyy: {
        _: 'dd-MM-yyyy'
      },
      dd_mmm_yy: {
        _: 'dd-MMM-yy',
        'zh_cn': 'dd-M-yy',
        'zh_tw': 'dd-M-yy',
        'ja': 'dd-M-yy',
        'ko': 'dd-M-yy'
      },
      dd_mmm_yyyy: {
        _: 'dd-MMM-yyyy',
        'zh_cn': 'dd-M-yyyy',
        'zh_tw': 'dd-M-yyyy',
        'ja': 'dd-M-yyyy',
        'ko': 'dd-M-yyyy'
      },
      ddmmmmyyyy: {
        _: 'dd MMMM yyyy',
        'zh_cn': 'yyyy年M月d日',
        'zh_tw': 'yyyy年M月d日',
        'ja': 'yyyy年M月d日',
        'ko': 'yyyy년M월d일',
        'de': 'dd. MMMM yyyy',
        'es': 'dd \\d\\e MMMM \\d\\e yyyy',
        'fr': 'd MMMM yyyy',
        'it': 'd MMMM yyyy',
        'nl': 'd MMMM yyyy',
        'pt_br': 'dd \\d\\e MMMM \\d\\e yyyy',
        'pt': 'dd \\d\\e MMMM \\d\\e yyyy',
        'ru': 'dd MMMM yyyy г.'
      },
      yyyy_mm_dd: {
        _: 'yyyy-MM-dd'
      },
      yyyy_mmm_dd: {
        _: 'yyyy-MMM-dd',
        'zh_cn': 'yyyy-M-dd',
        'zh_tw': 'yyyy-M-dd',
        'ja': 'yyyy-M-dd',
        'ko': 'yyyy-M-dd'
      },
      ddmmyyyy_de: {
        _: 'dd.MM.yyyy'
      },
      ddmmyyyy: {
        _: 'dd/MM/yyyy'
      },
      yyyymmdd: {
        _: 'yyyy/MM/dd'
      },
      yyyymd: {
        _: 'yyyy/M/d'
      },
      yyyy_mmmm_d: { // not in v1.4
        _: 'yyyy MMMM d',
        'zh_cn': 'yyyy年M月d日',
        'zh_tw': 'yyyy年M月d日',
        'ja': 'yyyy年M月d日',
        'ko': 'yyyy년M월d일'
      },
      longformat: {
        _: 'MMMM d, yyyy',
        'en': 'MMMM d, yyyy',
        'de': 'dd. MMMM yyyy',
        'es': 'dd \\d\\e MMMM \\d\\e yyyy',
        'fr': 'd MMMM yyyy',
        'it': 'd MMMM yyyy',
        'nl': 'd MMMM yyyy',
        'pt_br': 'dd \\d\\e MMMM \\d\\e yyyy',
        'pt': 'dd \\d\\e MMMM \\d\\e yyyy',
        'ru': 'dd MMMM yyyy г.',
        'zh_cn': 'yyyy年M月d日',
        'zh_tw': 'yyyy年M月d日',
        'ja': 'yyyy年M月d日',
        'ko': 'yyyy년M월d일'
      },
      custom: {
        _: 'custom'
      }
    },
    dateParsePattern: {
      dmy: {
        m: [5, 11, 17], d: [3, 9, 15], y: [20],
        regx: '^((((0?[1-9])|[12]\\d|3[01])[ ]*[^0-9][ ]*((0?(1|3|5|7|8))|10|12))|(((0?[1-9])|[12]\\d|30)[ ]*[^0-9][ ]*((0?(4|6|9))|11))|(((0?[1-9])|[12]\\d)[ ]*[^0-9][ ]*(0?2)))(([ ]*[^0-9][ ]*((19|20|)\\d\\d)[ ]*[^0-9]*)|)$'
      },
      mdy: {
        m: [3, 9, 15], d: [6, 12, 16], y: [20],
        regx: '^((((0?(1|3|5|7|8))|10|12)[ ]*[^0-9][ ]*((0?[1-9])|[12]\\d|3[01]))|(((0?(4|6|9))|11)[ ]*[^0-9][ ]*((0?[1-9])|[12]\\d|30))|((0?2)[ ]*[^0-9][ ]*((0?[1-9])|[12]\\d)))(([ ]*[^0-9][ ]*((19|20|)\\d\\d)[ ]*[^0-9]*)|)$'
      },
      ymd: {
        m: [5, 11, 17], d: [8, 14, 18], y: [1],
        regx: '^((19|20|)\\d\\d)[ ]*[^0-9][ ]*((((0?(1|3|5|7|8))|10|12)[ ]*[^0-9][ ]*((0?[1-9])|[12]\\d|3[01]))|(((0?(4|6|9))|11)[ ]*[^0-9][ ]*((0?[1-9])|[12]\\d|30))|((0?2)[ ]*[^0-9][ ]*((0?[1-9])|[12]\\d)))[ ]*[^0-9]*$'
      }
    },
    currencyISOtoSymbol: {
      afn: '؋',
      ars: '$',
      awg: 'ƒ',
      aud: '$',
      azn: '₼',
      bsd: '$',
      bbd: '$',
      byr: 'p.',
      bzd: 'BZ$',
      bmd: '$',
      bob: 'Bs.',
      bam: 'KM',
      bwp: 'P',
      bgn: 'лв',
      brl: 'R$',
      bnd: '$',
      khr: '៛',
      cad: '$',
      kyd: '$',
      clp: '$',
      cny: '¥',
      cop: '$',
      crc: '₡',
      hrk: 'kn',
      cup: '₱',
      czk: 'Kč',
      dkk: 'kr',
      dop: 'RD$',
      xcd: '$',
      egp: '£',
      svc: '$',
      eek: 'kr',
      eur: '€',
      fkp: '£',
      fjd: '$',
      ghc: '₵',
      gip: '£',
      gtq: 'Q',
      ggp: '£',
      gyd: '$',
      hnl: 'L',
      hkd: '$',
      huf: 'Ft',
      isk: 'kr',
      inr: '₹',
      idr: 'Rp',
      irr: '﷼',
      imp: '£',
      ils: '₪',
      jmd: 'J$',
      jpy: '¥',
      jep: '£',
      kes: 'KSh',
      kzt: 'лв',
      kpw: '₩',
      krw: '₩',
      kgs: 'лв',
      lak: '₭',
      lvl: 'Ls',
      lbp: '£',
      lrd: '$',
      ltl: 'Lt',
      mkd: 'ден',
      myr: 'RM',
      mur: '₨',
      mxn: '$',
      mnt: '₮',
      mzn: 'MT',
      nad: '$',
      npr: '₨',
      ang: 'ƒ',
      nzd: '$',
      nio: 'C$',
      ngn: '₦',
      nok: 'kr',
      omr: '﷼',
      pkr: '₨',
      pab: 'B/.',
      pyg: 'Gs',
      pen: 'S/.',
      php: '₱',
      pln: 'zł',
      qar: '﷼',
      ron: 'lei',
      rub: '₽',
      rmb: '￥',
      shp: '£',
      sar: '﷼',
      rsd: 'Дин.',
      scr: '₨',
      sgd: '$',
      sbd: '$',
      sos: 'S',
      zar: 'R',
      lkr: '₨',
      sek: 'kr',
      chf: 'CHF',
      srd: '$',
      syp: '£',
      tzs: 'TSh',
      twd: 'NT$',
      thb: '฿',
      ttd: 'TT$',
      'try': '₺',
      trl: '₤',
      tvd: '$',
      ugx: 'USh',
      uah: '₴',
      gbp: '£',
      usd: '$',
      uyu: '$U',
      uzs: 'лв',
      vef: 'Bs',
      vnd: '₫',
      yer: '﷼',
      zwd: 'Z$',
      amd: '֏'
    },
    currencyNumberFormatInfo: {
      'default': {
        positivePattern: '$n',
        negativePattern: '-$n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_1_comma_234_comma_567_period_89: {
        positivePattern: '$n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_space_1_period_234_period_567_comma_89: {
        positivePattern: '$ n',
        decimalSeparator: ',',
        groupSeparator: '.',
        groupDigits: 3,
        decimalDigits: 2
      },
      leading_1_period_234_period_567_comma_89_space_csym: {
        positivePattern: 'n $',
        decimalSeparator: ',',
        groupSeparator: '.',
        groupDigits: 3,
        decimalDigits: 2
      },
      leading_1_space_234_space_567_comma_89_space_csym: {
        positivePattern: 'n $',
        decimalSeparator: ',',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_space_1_quote_234_quote_567_period_89: {
        positivePattern: '$ n',
        decimalSeparator: '.',
        groupSeparator: '\'',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_1_comma_234_comma_567: {
        positivePattern: '$n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 0
      },
      csym_space_12_comma_34_comma_567_period_89: {
        positivePattern: '$ n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 2,
        decimalDigits: 2
      },
      csym_space_minus_12_comma_34_comma_567_period_89: {
        negativePattern: '$ -n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 2,
        decimalDigits: 2
      },
      csym_space_1234_comma_567_period_89: {
        positivePattern: '$ n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      },
      leading_1_space_234_space_567_period_89_space_csym: {
        positivePattern: 'n $',
        decimalSeparator: '.',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_space_1_space_234_space_567_comma_89: {
        positivePattern: '$ n',
        decimalSeparator: ',',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_space_1_space_234_space_567_period_89: {
        positivePattern: '$ n',
        decimalSeparator: '.',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      leading_1_space_234_space_567_comma_89_csym: {
        positivePattern: 'n$',
        decimalSeparator: ',',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      leading_1_comma_234_comma_567_period_89_space_csym: {
        positivePattern: 'n $',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_1_period_234_period_567: {
        positivePattern: '$n',
        decimalSeparator: ' ',
        groupSeparator: '.',
        groupDigits: 3,
        decimalDigits: 0
      },
      opar_csym_1_comma_234_comma_567_period_89_cpar: {
        negativePattern: '($n)',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_csym_1_comma_234_comma_567_period_89: {
        negativePattern: '-$n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_csym_space_1_period_234_period_567_comma_89: {
        negativePattern: '-$ n',
        decimalSeparator: ',',
        groupSeparator: '.',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_space_minus_1_period_234_period_567_comma_89: {
        negativePattern: '$ -n',
        decimalSeparator: ',',
        groupSeparator: '.',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_1_period_234_period_567_comma_89_space_csym: {
        negativePattern: '-n $',
        decimalSeparator: ',',
        groupSeparator: '.',
        groupDigits: 3,
        decimalDigits: 2
      },
      opar_1_space_234_space_567_comma_89_space_csym_cpar: {
        negativePattern: '(n $)',
        decimalSeparator: ',',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_1_space_234_space_567_comma_89_space_csym: {
        negativePattern: '-n $',
        decimalSeparator: ',',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_1_comma_234_comma_567_period_89_space_csym: {
        negativePattern: '-n $',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_minus_1_quote_234_quote_567_period_89: {
        negativePattern: '$-n',
        decimalSeparator: '.',
        groupSeparator: '\'',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_csym_1_period_234_period_567_comma_89: {
        negativePattern: '-$n',
        decimalSeparator: ',',
        groupSeparator: '.',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_csym_1_comma_234_comma_567: {
        negativePattern: '-$n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 0
      },
      opar_csym_space_1234_comma_567_period_89_cpar: {
        negativePattern: '($ n)',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_minus_12_comma_34_comma_567_period_89: {
        negativePattern: '$-n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_space_minus_1_space_234_space_567_comma_89: {
        negativePattern: '$ -n',
        decimalSeparator: ',',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      csym_space_minus_1_space_234_space_567_period_89: {
        negativePattern: '$ -n',
        decimalSeparator: '.',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_csym_space_1_space_234_space_567_comma_89: {
        negativePattern: '-$ n',
        decimalSeparator: ',',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_1_space_234_space_567_comma_89_csym: {
        negativePattern: '-n$',
        decimalSeparator: ',',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      minus_1_space_234_space_567_period_89_space_csym: {
        negativePattern: '-n $',
        decimalSeparator: '.',
        groupSeparator: ' ',
        groupDigits: 3,
        decimalDigits: 2
      },
      opar_csym_1_period_234_period_567_cpar: {
        negativePattern: '($n)',
        decimalSeparator: ' ',
        groupSeparator: '.',
        groupDigits: 3,
        decimalDigits: 0
      },
      opar_csym_1_comma_234_comma_567_cpar: {
        negativePattern: '($n)',
        decimalSeparator: ' ',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 0
      },
      csym_minus_1_comma_234_comma_567_period_89: {
        negativePattern: '$-n',
        decimalSeparator: '.',
        groupSeparator: ',',
        groupDigits: 3,
        decimalDigits: 2
      }
    },
    currencyNoDecimalDigitsIsoCode: {
      pyg: 'pyg',
      idr: 'idr',
      isk: 'isk',
      jpy: 'jpy',
      krw: 'krw',
      bnd: 'bnd',
      myr: 'myr'
    },
    currency3DecimalDigitsIsoCode: {
      // bhd: 'bhd',
      // iqd: 'iqd',
      // jod: 'jod',
      // kwd: 'kwd',
      // lyd: 'lyd',
      omr: 'omr',
      // tnd: 'tnd'
    },
    JapaneseEraInfo: [
      {
        yyyy: 'R',
        jaYyyy: '令和',
        year: 2019,
        startDate: '20190501'
      },
      {
        yyyy: 'H',
        jaYyyy: '平成',
        year: 1989,
        startDate: '19890108'
      },
      {
        yyyy: 'S',
        jaYyyy: '昭和',
        year: 1926,
        startDate: '19261226'
      }
    ],
    dateFormatLocalesInfo: {
      'ar.month': [
        'محرم', 'صفر', 'ربيع الأول', 'ربيع الثاني', 'جمادى الأولى', 'جمادى الثانية',
        'رجب', 'شعبان', 'رمضان', 'شوال', 'ذو القعدة', 'ذو الحجة'
      ],
      'ar.mshort': ['محرم', 'صفر', 'ربيع الأول', 'ربيع الثاني', 'جمادى الأولى', 'جمادى الثانية', 'رجب', 'شعبان', 'رمضان', 'شوال', 'ذو القعدة', 'ذو الحجة'],
      'ar.ampm': ['ص', 'م'],
      'ar.ampmshort': ['ص', 'م'],
      'ar.days': ['الأحد','الإثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'],
      'ar.dayshort': ['ح','ن','ث','ر','خ','ج','س'],
      'ar.firstday': 0,

      'bg_bg.month': [
        'януари', 'февруари', 'март', 'април', 'май', 'юни',
        'юли', 'август', 'септември', 'октомври', 'ноември', 'декември'
      ],
      'bg_bg.mshort': ['яну', 'фев', 'мар', 'апр', 'май', 'юни', 'юли', 'авг', 'сеп', 'окт', 'ное', 'дек'],
      'bg_bg.ampm': ['', ''],
      'bg_bg.ampmshort': ['', ''],
      'bg_bg.days': ['неделя','понеделник','вторник','сряда','четвъртък','петък','събота'],
      'bg_bg.dayshort': ['нд','пн','вт','ср','чт','пт','сб'],
      'bg_bg.firstday': 1,

      'cs_cz.month': [
        'leden', 'únor', 'březen', 'duben', 'květen', 'červen',
        'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'
      ],
      'cs_cz.mshort': ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
      'cs_cz.ampm': ['dop.', 'odp.'],
      'cs_cz.ampmshort': ['d', 'o'],
      'cs_cz.days': ['neděle','pondělí','úterý','středa','čtvrtek','pátek','sobota'],
      'cs_cz.dayshort': ['ne','po','út','st','čt','pá','so'],
      'cs_cz.firstday': 1,

      'da_dk.month': [
        'januar', 'februar', 'marts', 'april', 'maj', 'juni',
        'juli', 'august', 'september', 'oktober', 'november', 'december'
      ],
      'da_dk.mshort': ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      'da_dk.ampm': ['', ''],
      'da_dk.ampmshort': ['', ''],
      'da_dk.days': ['søndag','mandag','tirsdag','onsdag','torsdag','fredag','lørdag'],
      'da_dk.dayshort': ['sø','ma','ti','on','to','fr','lø'],
      'da_dk.firstday': 1,

      'de_de.month': [
        'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
        'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
      ],
      'de_de.mshort': ['Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      'de_de.ampm': ['', ''],
      'de_de.ampmshort': ['', ''],
      'de_de.days': ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
      'de_de.dayshort': ['So','Mo','Di','Mi','Do','Fr','Sa'],
      'de_de.firstday': 1,

      'el_gr.month': [
        'Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος',
        'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'
      ],
      'el_gr.mshort': ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαϊ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
      'el_gr.ampm': ['πμ', 'μμ'],
      'el_gr.ampmshort': ['π', 'μ'],
      'el_gr.days': ['Κυριακή','Δευτέρα','Τρίτη','Τετάρτη','Πέμπτη','Παρασκευή','Σάββατο'],
      'el_gr.dayshort': ['Κυ','Δε','Τρ','Τε','Πε','Πα','Σα'],
      'el_gr.firstday': 1,

      'en_au.month': [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      'en_au.mshort': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      'en_au.ampm': ['AM', 'PM'],
      'en_au.ampmshort': ['A', 'P'],
      'en_au.days': ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      'en_au.dayshort': ['Su','Mo','Tu','We','Th','Fr','Sa'],
      'en_au.firstday': 1,

      'en_gb.month': [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      'en_gb.mshort': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      'en_gb.ampm': ['AM', 'PM'],
      'en_gb.ampmshort': ['A', 'P'],
      'en_gb.days': ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      'en_gb.dayshort': ['Su','Mo','Tu','We','Th','Fr','Sa'],
      'en_gb.firstday': 1,

      'en_us.month': [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      'en_us.mshort': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      'en_us.ampm': ['AM', 'PM'],
      'en_us.ampmshort': ['A', 'P'],
      'en_us.days': ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      'en_us.dayshort': ['Su','Mo','Tu','We','Th','Fr','Sa'],
      'en_us.firstday': 0,

      'es_es.month': [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
      ],
      'es_es.mshort': ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sep.', 'oct.', 'nov.', 'dic.'],
      'es_es.ampm': ['', ''],
      'es_es.ampmshort': ['', ''],
      'es_es.days': ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'],
      'es_es.dayshort': ['D','L','M','X','J','V','S'],
      'es_es.firstday': 1,

      'es_mx.month': [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
      ],
      'es_mx.mshort': ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sep.', 'oct.', 'nov.', 'dic.'],
      'es_mx.ampm': ['a. m.', 'p. m.'],
      'es_mx.ampmshort': ['a', 'p'],
      'es_mx.days': ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'],
      'es_mx.dayshort': ['do.','lu.','ma.','mi.','ju.','vi.','sá.'],
      'es_mx.firstday': 0,

      'et_ee.month': [
        'jaanuar', 'veebruar', 'märts', 'aprill', 'mai', 'juuni',
        'juuli', 'august', 'september', 'oktoober', 'november', 'detsember'
      ],
      'et_ee.mshort': ['jaan', 'veebr', 'märts', 'apr', 'mai', 'juuni', 'juuli', 'aug', 'sept', 'okt', 'nov', 'dets'],
      'et_ee.ampm': ['AM', 'PM'],
      'et_ee.ampmshort': ['A', 'P'],
      'et_ee.days': ['pühapäev','esmaspäev','teisipäev','kolmapäev','neljapäev','reede','laupäev'],
      'et_ee.dayshort': ['P','E','T','K','N','R','L'],
      'et_ee.firstday': 1,

      'fa_ir.month': [
        'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
        'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
      ],
      'fa_ir.mshort': ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
      'fa_ir.ampm': ['ق.ظ', 'ب.ظ'],
      'fa_ir.ampmshort': ['ق', 'ب'],
      'fa_ir.days': ['يكشنبه','دوشنبه','سه شنبه','چهارشنبه','پنجشنبه','جمعه','شنبه'],
      'fa_ir.dayshort': ['ی','د','س','چ','پ','ج','ش'],
      'fa_ir.firstday': 6,

      'fi_fi.month': [
        'tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu',
        'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'
      ],
      'fi_fi.mshort': ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
      'fi_fi.ampm': ['ap.', 'ip.'],
      'fi_fi.ampmshort': ['a', 'i'],
      'fi_fi.days': ['sunnuntai','maanantai','tiistai','keskiviikko','torstai','perjantai','lauantai'],
      'fi_fi.dayshort': ['su','ma','ti','ke','to','pe','la'],
      'fi_fi.firstday': 1,

      'fr_ca.month': [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
      ],
      'fr_ca.mshort': ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
      'fr_ca.ampm': ['', ''],
      'fr_ca.ampmshort': ['', ''],
      'fr_ca.days': ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'],
      'fr_ca.dayshort': ['di','lu','ma','me','je','ve','sa'],
      'fr_ca.firstday': 0,

      'fr_fr.month': [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
      ],
      'fr_fr.mshort': ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
      'fr_fr.ampm': ['', ''],
      'fr_fr.ampmshort': ['', ''],
      'fr_fr.days': ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'],
      'fr_fr.dayshort': ['di','lu','ma','me','je','ve','sa'],
      'fr_fr.firstday': 1,

      'he_il.month': [
        'ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני',
        'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'
      ],
      'he_il.mshort': ['ינו', 'פבר', 'מרץ', 'אפר', 'מאי', 'יונ', 'יול', 'אוג', 'ספט', 'אוק', 'נוב', 'דצמ'],
      'he_il.ampm': ['AM', 'PM'],
      'he_il.ampmshort': ['A', 'P'],
      'he_il.days': ['יום ראשון','יום שני','יום שלישי','יום רביעי','יום חמישי','יום שישי','שבת'],
      'he_il.dayshort': ['א','ב','ג','ד','ה','ו','ש'],
      'he_il.firstday': 0,

      'hi_in.month': [
        'जनवरी', 'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून',
        'जुलाई', 'अगस्त', 'सितम्बर', 'अक्तूबर', 'नवम्बर', 'दिसम्बर'
      ],
      'hi_in.mshort': ['जनवरी', 'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितम्बर', 'अक्तूबर', 'नवम्बर', 'दिसम्बर'],
      'hi_in.ampm': ['पूर्वाह्न', 'अपराह्न'],
      'hi_in.ampmshort': ['प', 'अ'],
      'hi_in.days': ['रविवार','सोमवार','मंगलवार','बुधवार','गुरुवार','शुक्रवार','शनिवार'],
      'hi_in.dayshort': ['र','स','म','ब','ग','श','श'],
      'hi_in.firstday': 1,

      'hr_hr.month': [
        'siječanj', 'veljača', 'ožujak', 'travanj', 'svibanj', 'lipanj',
        'srpanj', 'kolovoz', 'rujan', 'listopad', 'studeni', 'prosinac'
      ],
      'hr_hr.mshort': ['sij', 'vlj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
      'hr_hr.ampm': ['', ''],
      'hr_hr.ampmshort': ['', ''],
      'hr_hr.days': ['nedjelja','ponedjeljak','utorak','srijeda','četvrtak','petak','subota'],
      'hr_hr.dayshort': ['ne','po','ut','sr','če','pe','su'],
      'hr_hr.firstday': 1,

      'hu_hu.month': [
        'január', 'február', 'március', 'április', 'május', 'június',
        'július', 'augusztus', 'szeptember', 'október', 'november', 'december'
      ],
      'hu_hu.mshort': ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'],
      'hu_hu.ampm': ['de.', 'du.'],
      'hu_hu.ampmshort': ['d', 'u'],
      'hu_hu.days': ['vasárnap','hétfő','kedd','szerda','csütörtök','péntek','szombat'],
      'hu_hu.dayshort': ['V','H','K','Sze','Cs','P','Szo'],
      'hu_hu.firstday': 1,

      'hy_am.month': [
        'Հունվար', 'Փետրվար', 'Մարտ', 'Ապրիլ', 'Մայիս', 'Հունիս',
        'Հուլիս', 'Օգոստոս', 'Սեպտեմբեր', 'Հոկտեմբեր', 'Նոյեմբեր', 'Դեկտեմբեր'
      ],
      'hy_am.mshort': ['Հնվ', 'Փտվ', 'Մրտ', 'Ապր', 'Մյս', 'Հնս', 'Հլս', 'Օգս', 'Սպտ', 'Հկտ', 'Նյմ', 'Դկտ'],
      'hy_am.ampm': ['', ''],
      'hy_am.ampmshort': ['', ''],
      'hy_am.days': ['Կիրակի','Երկուշաբթի','Երեքշաբթի','Չորեքշաբթի','Հինգշաբթի','Ուրբաթ','Շաբաթ'],
      'hy_am.dayshort': ['Կ','Ե','Ե','Չ','Հ','Ո','Շ'],
      'hy_am.firstday': 1,

      'id_id.month': [
        'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
        'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
      ],
      'id_id.mshort': ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agt', 'Sep', 'Okt', 'Nov', 'Des'],
      'id_id.ampm': ['AM', 'PM'],
      'id_id.ampmshort': ['A', 'P'],
      'id_id.days': ['Minggu','Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'],
      'id_id.dayshort': ['Min','Sen','Sel','Rab','Kam','Jum','Sab'],
      'id_id.firstday': 0,

      'it_it.month': [
        'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
        'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'
      ],
      'it_it.mshort': ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
      'it_it.ampm': ['', ''],
      'it_it.ampmshort': ['', ''],
      'it_it.days': ['domenica','lunedì','martedì','mercoledì','giovedì','venerdì','sabato'],
      'it_it.dayshort': ['do','lu','ma','me','gi','ve','sa'],
      'it_it.firstday': 1,

      'ja_jp.month': [
        '1月', '2月', '3月', '4月', '5月', '6月',
        '7月', '8月', '9月', '10月', '11月', '12月'
      ],
      'ja_jp.mshort': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      'ja_jp.ampm': ['午前', '午後'],
      'ja_jp.ampmshort': ['前', '後'],
      'ja_jp.days': ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
      'ja_jp.dayshort': ['日','月','火','水','木','金','土'],
      'ja_jp.firstday': 0,

      'ko_kr.month': [
        '1월', '2월', '3월', '4월', '5월', '6월',
        '7월', '8월', '9월', '10월', '11월', '12월'
      ],
      'ko_kr.mshort': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      'ko_kr.ampm': ['오전', '오후'],
      'ko_kr.ampmshort': ['전', '후'],
      'ko_kr.days': ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'],
      'ko_kr.dayshort': ['일','월','화','수','목','금','토'],
      'ko_kr.firstday': 0,

      'lt_lt.month': [
        'sausis', 'vasaris', 'kovas', 'balandis', 'gegužė', 'birželis',
        'liepa', 'rugpjūtis', 'rugsėjis', 'spalis', 'lapkritis', 'gruodis'
      ],
      'lt_lt.mshort': ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.', 'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
      'lt_lt.ampm': ['priešpiet', 'popiet'],
      'lt_lt.ampmshort': ['p', 'o'],
      'lt_lt.days': ['sekmadienis','pirmadienis','antradienis','trečiadienis','ketvirtadienis','penktadienis','šeštadienis'],
      'lt_lt.dayshort': ['Sk','Pr','An','Tr','Kt','Pn','Št'],
      'lt_lt.firstday': 1,

      'lv_lv.month': [
        'janvāris', 'februāris', 'marts', 'aprīlis', 'maijs', 'jūnijs',
        'jūlijs', 'augusts', 'septembris', 'oktobris', 'novembris', 'decembris'
      ],
      'lv_lv.mshort': ['janv.', 'febr.', 'marts', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
      'lv_lv.ampm': ['priekšp.', 'pēcp.'],
      'lv_lv.ampmshort': ['p', 'ē'],
      'lv_lv.days': ['svētdiena','pirmdiena','otrdiena','trešdiena','ceturtdiena','piektdiena','sestdiena'],
      'lv_lv.dayshort': ['Sv','Pr','Ot','Tr','Ce','Pk','Se'],
      'lv_lv.firstday': 1,

      'ms_my.month': [
        'Januari', 'Februari', 'Mac', 'April', 'Mei', 'Jun',
        'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember'
      ],
      'ms_my.mshort': ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'],
      'ms_my.ampm': ['PG', 'PTG'],
      'ms_my.ampmshort': ['G', 'T'],
      'ms_my.days': ['Ahad','Isnin','Selasa','Rabu','Khamis','Jumaat','Sabtu'],
      'ms_my.dayshort': ['Ah','Is','Se','Ra','Kh','Ju','Sa'],
      'ms_my.firstday': 1,

      'nb_no.month': [
        'januar', 'februar', 'mars', 'april', 'mai', 'juni',
        'juli', 'august', 'september', 'oktober', 'november', 'desember'
      ],
      'nb_no.mshort': ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'],
      'nb_no.ampm': ['a.m.', 'p.m.'],
      'nb_no.ampmshort': ['a', 'p'],
      'nb_no.days': ['søndag','mandag','tirsdag','onsdag','torsdag','fredag','lørdag'],
      'nb_no.dayshort': ['sø.','ma.','ti.','on.','to.','fr.','lø.'],
      'nb_no.firstday': 1,

      'nl_nl.month': [
        'januari', 'februari', 'maart', 'april', 'mei', 'juni',
        'juli', 'augustus', 'september', 'oktober', 'november', 'december'
      ],
      'nl_nl.mshort': ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      'nl_nl.ampm': ['', ''],
      'nl_nl.ampmshort': ['', ''],
      'nl_nl.days': ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'],
      'nl_nl.dayshort': ['zo','ma','di','wo','do','vr','za'],
      'nl_nl.firstday': 1,

      'pl_pl.month': [
        'styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec',
        'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'
      ],
      'pl_pl.mshort': ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
      'pl_pl.ampm': ['AM', 'PM'],
      'pl_pl.ampmshort': ['A', 'P'],
      'pl_pl.days': ['niedziela','poniedziałek','wtorek','środa','czwartek','piątek','sobota'],
      'pl_pl.dayshort': ['nie','pon','wto','śro','czw','pią','sob'],
      'pl_pl.firstday': 1,

      'pt_br.month': [
        'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
      ],
      'pt_br.mshort': ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      'pt_br.ampm': ['', ''],
      'pt_br.ampmshort': ['', ''],
      'pt_br.days': ['domingo','segunda-feira','terça-feira','quarta-feira','quinta-feira','sexta-feira','sábado'],
      'pt_br.dayshort': ['D','S','T','Q','Q','S','S'],
      'pt_br.firstday': 0,

      'pt_pt.month': [
        'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
      ],
      'pt_pt.mshort': ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      'pt_pt.ampm': ['', ''],
      'pt_pt.ampmshort': ['', ''],
      'pt_pt.days': ['domingo','segunda-feira','terça-feira','quarta-feira','quinta-feira','sexta-feira','sábado'],
      'pt_pt.dayshort': ['D','S','T','Q','Q','S','S'],
      'pt_pt.firstday': 0,

      'ro_ro.month': [
        'ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie',
        'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'
      ],
      'ro_ro.mshort': ['ian.', 'feb.', 'mar.', 'apr.', 'mai', 'iun.', 'iul.', 'aug.', 'sept.', 'oct.', 'nov.', 'dec.'],
      'ro_ro.ampm': ['a.m.', 'p.m.'],
      'ro_ro.ampmshort': ['a', 'p'],
      'ro_ro.days': ['duminică','luni','marți','miercuri','joi','vineri','sâmbătă'],
      'ro_ro.dayshort': ['du.','lu.','ma.','mi.','joi','vi.','sâ.'],
      'ro_ro.firstday': 1,

      'ru_ru.month': [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      'ru_ru.mshort': ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
      'ru_ru.ampm': ['', ''],
      'ru_ru.ampmshort': ['', ''],
      'ru_ru.days': ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
      'ru_ru.dayshort': ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
      'ru_ru.firstday': 1,

      'sk_sk.month': [
        'január', 'február', 'marec', 'apríl', 'máj', 'jún',
        'júl', 'august', 'september', 'október', 'november', 'december'
      ],
      'sk_sk.mshort': ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
      'sk_sk.ampm': ['AM', 'PM'],
      'sk_sk.ampmshort': ['A', 'P'],
      'sk_sk.days': ['nedeľa','pondelok','utorok','streda','štvrtok','piatok','sobota'],
      'sk_sk.dayshort': ['ne','po','ut','st','št','pi','so'],
      'sk_sk.firstday': 1,

      'sl_si.month': [
        'januar', 'februar', 'marec', 'april', 'maj', 'junij',
        'julij', 'avgust', 'september', 'oktober', 'november', 'december'
      ],
      'sl_si.mshort': ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
      'sl_si.ampm': ['dop.', 'pop.'],
      'sl_si.ampmshort': ['d', 'p'],
      'sl_si.days': ['nedelja','ponedeljek','torek','sreda','četrtek','petek','sobota'],
      'sl_si.dayshort': ['ned.','pon.','tor.','sre.','čet.','pet.','sob.'],
      'sl_si.firstday': 1,

      'sr.month': [
        'januar', 'februar', 'mart', 'april', 'maj', 'jun',
        'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'
      ],
      'sr.mshort': ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
      'sr.ampm': ['pre podne', 'po podne'],
      'sr.ampmshort': ['p', 'o'],
      'sr.days': ['nedelja','ponedeljak','utorak','sreda','četvrtak','petak','subota'],
      'sr.dayshort': ['ne','po','ut','sr','če','pe','su'],
      'sr.firstday': 1,

      'sv_se.month': [
        'januari', 'februari', 'mars', 'april', 'maj', 'juni',
        'juli', 'augusti', 'september', 'oktober', 'november', 'december'
      ],
      'sv_se.mshort': ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      'sv_se.ampm': ['', ''],
      'sv_se.ampmshort': ['', ''],
      'sv_se.days': ['söndag','måndag','tisdag','onsdag','torsdag','fredag','lördag'],
      'sv_se.dayshort': ['sö','må','ti','on','to','fr','lö'],
      'sv_se.firstday': 1,

      'th_th.month': [
        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ],
      'th_th.mshort': ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
      'th_th.ampm': ['AM', 'PM'],
      'th_th.ampmshort': ['A', 'P'],
      'th_th.days': ['อาทิตย์','จันทร์','อังคาร','พุธ','พฤหัสบดี','ศุกร์','เสาร์'],
      'th_th.dayshort': ['อา','จ','อ','พ','พฤ','ศ','ส'],
      'th_th.firstday': 1,

      'tr_tr.month': [
        'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
        'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
      ],
      'tr_tr.mshort': ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
      'tr_tr.ampm': ['ÖÖ', 'ÖS'],
      'tr_tr.ampmshort': ['Ö', 'S'],
      'tr_tr.days': ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'],
      'tr_tr.dayshort': ['Pa','Pt','Sa','Ça','Pe','Cu','Ct'],
      'tr_tr.firstday': 1,

      'uk_ua.month': [
        'січень', 'лютий', 'березень', 'квітень', 'травень', 'червень',
        'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень'
      ],
      'uk_ua.mshort': ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
      'uk_ua.ampm': ['', ''],
      'uk_ua.ampmshort': ['', ''],
      'uk_ua.days': ['неділя','понеділок','вівторок','середа','четвер','п\'ятниця','субота'],
      'uk_ua.dayshort': ['Нд','Пн','Вт','Ср','Чт','Пт','Сб'],
      'uk_ua.firstday': 1,

      'vi_vn.month': [
        'Tháng Giêng', 'Tháng Hai', 'Tháng Ba', 'Tháng Tư', 'Tháng Năm', 'Tháng Sáu',
        'Tháng Bảy', 'Tháng Tám', 'Tháng Chín', 'Tháng Mười', 'Tháng Mười Một', 'Tháng Mười Hai'
      ],
      'vi_vn.mshort': ['Thg1', 'Thg2', 'Thg3', 'Thg4', 'Thg5', 'Thg6', 'Thg7', 'Thg8', 'Thg9', 'Thg10', 'Thg11', 'Thg12'],
      'vi_vn.ampm': ['SA', 'CH'],
      'vi_vn.ampmshort': ['S', 'C'],
      'vi_vn.days': ['Chủ Nhật','Thứ Hai','Thứ Ba','Thứ Tư','Thứ Năm','Thứ Sáu','Thứ Bảy'],
      'vi_vn.dayshort': ['C','H','B','T','N','S','B'],
      'vi_vn.firstday': 1,

      'zh_cn.month': [
        '一月', '二月', '三月', '四月', '五月', '六月',
        '七月', '八月', '九月', '十月', '十一月', '十二月'
      ],
      'zh_cn.mshort': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      'zh_cn.ampm': ['上午', '下午'],
      'zh_cn.ampmshort': ['上', '下'],
      'zh_cn.days': ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
      'zh_cn.dayshort': ['日','一','二','三','四','五','六'],
      'zh_cn.firstday': 1,

      'zh_tw.month': [
        '一月', '二月', '三月', '四月', '五月', '六月',
        '七月', '八月', '九月', '十月', '十一月', '十二月'
      ],
      'zh_tw.mshort': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      'zh_tw.ampm': ['上午', '下午'],
      'zh_tw.ampmshort': ['上', '下'],
      'zh_tw.days': ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
      'zh_tw.dayshort': ['日','一','二','三','四','五','六'],
      'zh_tw.firstday': 0,
    },
    languageToRegion: {
      bg: 'bg_bg',
      cs: 'cs_cz',
      da: 'da_dk',
      de: 'de_de',
      el: 'el_gr',
      en: 'en_us',
      es: 'es_es',
      et: 'et_ee',
      fa: 'fa_ir',
      fi: 'fi_fi',
      fr: 'fr_fr',
      he: 'he_il',
      hi: 'hi_in',
      hr: 'hr_hr',
      hu: 'hu_hu',
      hy: 'hy_am',
      id: 'id_id',
      it: 'it_it',
      ja: 'ja_jp',
      ko: 'ko_kr',
      lt: 'lt_lt',
      lv: 'lv_lv',
      ms: 'ms_my',
      nb: 'nb_no',
      no: 'nb_no',
      nl: 'nl_nl',
      pl: 'pl_pl',
      pt: 'pt_pt',
      ro: 'ro_ro',
      ru: 'ru_ru',
      sk: 'sk_sk',
      sl: 'sl_si',
      sv: 'sv_se',
      th: 'th_th',
      tr: 'tr_tr',
      uk: 'uk_ua',
      vi: 'vi_vn',
    },
    metaData: {
      uiLanguage: [
        {value: 'en',    display: 'English' },
        {value: 'de',    display: 'Deutsch' },
        {value: 'es',    display: 'Español' },
        {value: 'fr',    display: 'Français' },
        {value: 'it',    display: 'Italiano' },
        {value: 'nl',    display: 'Nederlands' },
        {value: 'pl',    display: 'Polski' },
        {value: 'pt_BR', display: 'Português (Brasil)' },
        {value: 'pt',    display: 'Português (Portugal)' },
        {value: 'ru',    display: 'Русский' },
        {value: 'zh_TW', display: '中文(繁体)' },
        {value: 'zh_CN', display: '中文(简体)' },
        {value: 'ja',    display: '日本語' },
        {value: 'ko',    display: '한국어'}
      ],
      locale: [
        {value: 'ar',    display: 'العربية‏' },
        {value: 'bg',    display: 'Български' },
        {value: 'cs',    display: 'Čeština' },
        {value: 'zh_CN', display: '中文 (简体)' },
        {value: 'zh_TW', display: '中文 (台灣)' },
        {value: 'hr',    display: 'Hrvatski' },
        {value: 'da',    display: 'Dansk' },
        {value: 'nl',    display: 'Nederlandse' },
        {value: 'en',    display: 'English (US)' },
        {value: 'en_GB', display: 'English (UK)' },
        {value: 'et',    display: 'Eesti' },
        {value: 'fa',    display: 'فارسی' },
        {value: 'fi',    display: 'Suomi' },
        {value: 'fr',    display: 'Français (France)' },
        {value: 'fr_CA', display: 'Française (Canada)' },
        {value: 'de',    display: 'Deutsch' },
        {value: 'el',    display: 'Ελληνικά' },
        {value: 'he',    display: 'עברית‏' },
        {value: 'hi',    display: 'हिन्दी' },
        {value: 'hu',    display: 'Magyar' },
        {value: 'hy',    display: 'հայերեն' },
        {value: 'id',    display: 'Bahasa Indonesia' },
        {value: 'it',    display: 'Italiano' },
        {value: 'ja',    display: '日本語' },
        {value: 'ko',    display: '한국어' },
        {value: 'lv',    display: 'Latviešu' },
        {value: 'lt',    display: 'Lietuvių' },
        {value: 'ms',    display: 'Bahasa Melayu' },
        {value: 'no',    display: 'Norsk' },
        {value: 'pl',    display: 'Polski' },
        {value: 'pt',    display: 'Português (Portugal)' },
        {value: 'pt_BR', display: 'Português (Brasil)' },
        {value: 'ro',    display: 'Română' },
        {value: 'ru',    display: 'Русский' },
        {value: 'sr',    display: 'Српски' },
        {value: 'sk',    display: 'Slovenčina' },
        {value: 'sl',    display: 'Slovenščina' },
        {value: 'es',    display: 'Español' },
        {value: 'es_MX', display: 'Español (América Latina)' },
        {value: 'sv',    display: 'Svenska' },
        {value: 'th',    display: 'ภาษาไทย' },
        {value: 'tr',    display: 'Türkçe' },
        {value: 'uk',    display: 'Українська' },
        {value: 'vi',    display: 'Việt' },
      ],
      regionName: [
        {value: 'ar',    display: 'Arabic'},
        {value: 'bg_bg', display: 'Bulgarian (Bulgaria)'},
        {value: 'cs_cz', display: 'Czech (Czech Republic)'},
        {value: 'da_dk', display: 'Danish (Denmark)'},
        {value: 'de_de', display: 'German (Germany)'},
        {value: 'el_gr', display: 'Greek (Greece)'},
        {value: 'en_au', display: 'English (Australia)'},
        {value: 'en_gb', display: 'English (United Kingdom)'},
        {value: 'en_us', display: 'English (United States)'},
        {value: 'es_es', display: 'Spanish (Spain)'},
        {value: 'es_mx', display: 'Spanish (Mexico)'},
        {value: 'et_ee', display: 'Estonian (Estonia)'},
        {value: 'fa_ir', display: 'Persian'},
        {value: 'fi_fi', display: 'Finnish (Finland)'},
        {value: 'fr_ca', display: 'French (Canada)'},
        {value: 'fr_fr', display: 'French (France)'},
        {value: 'he_il', display: 'Hebrew (Israel)'},
        {value: 'hi_in', display: 'Hindi (India)'},
        {value: 'hr_hr', display: 'Croatian (Croatia)'},
        {value: 'hu_hu', display: 'Hungarian (Hungary)'},
        {value: 'hy_am', display: 'Armenian (Armenia)'},
        {value: 'id_id', display: 'Indonesian (Indonesia)'},
        {value: 'it_it', display: 'Italian (Italy)'},
        {value: 'ja_jp', display: 'Japanese (Japan)'},
        {value: 'ko_kr', display: 'Korean (Korea)'},
        {value: 'lt_lt', display: 'Lithuanian (Lithuania)'},
        {value: 'lv_lv', display: 'Latvian (Latvia)'},
        {value: 'ms_my', display: 'Malay (Malaysia)'},
        {value: 'nb_no', display: 'Norwegian, Bokmål (Norway)'},
        {value: 'nl_nl', display: 'Dutch (Netherlands)'},
        {value: 'pl_pl', display: 'Polish (Poland)'},
        {value: 'pt_br', display: 'Portuguese (Brazil)'},
        {value: 'pt_pt', display: 'Portuguese (Portugal)'},
        {value: 'ro_ro', display: 'Romanian (Romania)'},
        {value: 'ru_ru', display: 'Russian (Russia)'},
        {value: 'sk_sk', display: 'Slovak (Slovakia)'},
        {value: 'sl_si', display: 'Slovenian (Slovenia)'},
        {value: 'sr',    display: 'Serbian'},
        {value: 'sv_se', display: 'Swedish (Sweden)'},
        {value: 'th_th', display: 'Thai (Thailand)'},
        {value: 'tr_tr', display: 'Turkish (Turkey)'},
        {value: 'uk_ua', display: 'Ukrainian (Ukraine)'},
        {value: 'vi_vn', display: 'Vietnamese (Vietnam)'},
        {value: 'zh_cn', display: 'Chinese (Simplified, China)'},
        {value: 'zh_tw', display: 'Chinese (Traditional, Taiwan)'},
      ],
      calendarType: [
        {value: 'gregorian', display: 'Gregorian'},
        {value: 'japanese', display: 'Japanese'},
      ],
      currencyPositiveFormat: [
        {value: 'csym_1_comma_234_comma_567_period_89', display: '$123,456,789.00'},
        {value: 'csym_space_1234_comma_567_period_89', display: '$ 123456,789.00'},   // Use '$ 123,456,789.00'
        {value: 'csym_1_comma_234_comma_567', display: '$123,456,789.00'},
        {value: 'leading_1_comma_234_comma_567_period_89_space_csym', display: '123,456,789.00 $'},
        {value: 'csym_space_12_comma_34_comma_567_period_89', display: '$ 12,34,56,789.00'}, // Indian Rupee - INR
        {value: 'csym_space_1_period_234_period_567_comma_89', display: '$ 123.456.789,00'},
        {value: 'leading_1_period_234_period_567_comma_89_space_csym', display: '123.456.789,00 $'},
        {value: 'leading_1_space_234_space_567_comma_89_space_csym', display: '123 456 789,00 $'},
        {value: 'csym_space_1_quote_234_quote_567_period_89', display: '$ 123\'456\'789.00'},
        {value: 'leading_1_space_234_space_567_period_89_space_csym', display: '123 456 789.00 $'},
        {value: 'csym_space_1_space_234_space_567_comma_89', display: '$ 123 456 789,00'},
        {value: 'csym_space_1_space_234_space_567_period_89', display: '$ 123 456 789.00'},
        {value: 'leading_1_space_234_space_567_comma_89_csym', display: '123 456 789,00$'},
        {value: 'csym_1_period_234_period_567', display: '$123.456.789'},
      ],
      currencyNegativeFormat: [
        {value: 'opar_csym_1_comma_234_comma_567_period_89_cpar', display: '($123,456,789.00)'},
        {value: 'minus_csym_1_comma_234_comma_567_period_89', display: '-$123,456,789.00'},
        {value: 'minus_csym_1_comma_234_comma_567',           display: '-$123,456,789' },
        {value: 'opar_csym_space_1234_comma_567_period_89_cpar', display: '($ 123456,789.00)'},  // Use '($ 123,456,789.00)'
        {value: 'csym_space_minus_12_comma_34_comma_567_period_89', display: '$ -12,34,56,789.00'}, // Indian Rupee - INR
        {value: 'minus_csym_space_1_period_234_period_567_comma_89', display: '-$ 123.456.789,00'},
        {value: 'csym_space_minus_1_period_234_period_567_comma_89', display: '$ -123.456.789,00'},
        {value: 'minus_1_period_234_period_567_comma_89_space_csym', display: '-123.456.789,00 $'},
        {value: 'minus_1_comma_234_comma_567_period_89_space_csym', display: '-123,456,789.00 $'},
        {value: 'minus_csym_1_period_234_period_567_comma_89', display: '-$123.456.789,00'},
        {value: 'opar_1_space_234_space_567_comma_89_space_csym_cpar', display: '(123 456 789,00 $)'},
        {value: 'minus_1_space_234_space_567_comma_89_space_csym', display: '-123 456 789,00 $'},
        {value: 'csym_minus_1_quote_234_quote_567_period_89', display: '$-123\'456\'789.00'},
        {value: 'csym_space_minus_1_space_234_space_567_comma_89', display: '$ -123 456 789,00'},
        {value: 'csym_space_minus_1_space_234_space_567_period_89', display: '$ -123 456 789.00'},
        {value: 'minus_csym_space_1_space_234_space_567_comma_89', display: '-$ 123 456 789,00'},
        {value: 'minus_1_space_234_space_567_comma_89_csym', display: '-123 456 789,00$'},
        {value: 'minus_1_space_234_space_567_period_89_space_csym', display: '-123 456 789.00 $'},
        {value: 'opar_csym_1_period_234_period_567_cpar', display: '($123.456.789)'},
        {value: 'opar_csym_1_comma_234_comma_567_cpar', display: '($123,456,789)'},
        {value: 'csym_minus_1_comma_234_comma_567_period_89', display: '$-123,456,789.00'},
      ],
      currencyCode: [
        {value: 'usd', display: '$'},
        {value: 'jpy', display: '¥'},
        {value: 'eur', display: '€'},
        {value: 'gbp', display: '£'},
      ],
      nameFormat: [
        {value: 'full', display: 'Default'},
        {value: 'last_first', display: 'Last First'},
        {value: 'last_first_cjk', display: 'Last First (Only Chinese or Japanese)'},
      ],
      initialFormat: [
        {value: 'first1last1', display: 'Default (one from each name)' },
        {value: 'first2' ,     display: 'Two from first name' },
        {value: 'last2' ,      display: 'Two from last name' },
        {value: 'last2_cjk' ,  display: 'Two from last name (Only Chinese or Japanese)' },
      ],
      addressFormat: [
        {value: 'en_us', display: 'Default' },
        {value: 'ja_jp', display: 'Japanese/Korean' },
        {value: 'zh_cn_tw', display: 'Chinese' },
      ],
      timeFormat: [
        {value: 'none', display: ''},
        {value: 'hhmm', display: ''},
        {value: 'hmm', display: ''},
        {value: 'hhmmss', display: ''},
        {value: 'hmmss', display: ''},
        {value: 'hhmmtt', display: ''},
        {value: 'hmmtt', display: ''},
        {value: 'hhmmsstt', display: ''},
        {value: 'hmmsstt', display: ''},
      ],
      dateFormat: [
        {value: 'default', display: ''},
        {value: 'mdyyyy', display: ''},
        {value: 'mm_dd_yyyy', display: ''},
        {value: 'mmddyyyy', display: ''},
        {value: 'mmddyy', display: ''},
        {value: 'mmm_dd_yyyy', display: ''},
        {value: 'mmmd_yyyy', display: ''},
        {value: 'mmmmd_yyyy', display: ''},
        {value: 'd_m_yyyy', display: ''},
        {value: 'dd_mm_yy', display: ''},
        {value: 'dd_mm_yyyy', display: ''},
        {value: 'dd_mmm_yy', display: ''},
        {value: 'dd_mmm_yyyy', display: ''},
        {value: 'ddmmmmyyyy', display: ''},
        {value: 'yyyy_mm_dd', display: ''},
        {value: 'yyyy_mmm_dd', display: ''},
        {value: 'dmyyyy', display: ''},
        {value: 'ddmmyyyy_de', display: ''},
        {value: 'ddmmyyyy', display: ''},
        {value: 'yyyymmdd', display: ''},
        {value: 'yyyymd', display: ''},
        {value: 'yyyy_mmmm_d', display: ''},
        {value: 'longformat', display: ''},
      ],
    },
    listFormatters: {
      unitShort: {
        default: {
          start: '{0}, {1}',
          middle: '{0}, {1}',
          end: '{0}, {1}',
          two: '{0}, {1}'
        },
        ar: {
          start: '{0}، و{1}',
          middle: '{0}، و{1}',
          end: '{0}، و{1}',
          two: '{0} و{1}'
        },
        bg: {
          two: '{0} и {1}'
        },
        cs: {
          end: '{0} a {1}',
        },
        da: {
          end: '{0} og {1}',
          two: '{0} og {1}'
        },
        de: {
          end: '{0} und {1}',
        },
        es: {
          two: '{0} y {1}'
        },
        fa: {
          start: '{0}،‏ {1}',
          middle: '{0}،‏ {1}',
          end: '{0}،‏ {1}',
          two: '{0}،‏ {1}'
        },
        fr: {
          end: '{0} et {1}',
          two: '{0} et {1}'
        },
        hu: {
          end: '{0} és {1}',
          two: '{0} és {1}'
        },
        hy: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} և {1}',
          two: '{0} և {1}'
        },
        it: {
          end: '{0} e {1}',
          two: '{0} e {1}'
        },
        ja: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} {1}',
          two: '{0} {1}'
        },
        ko: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} {1}',
          two: '{0} {1}'
        },
        lt: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} {1}',
          two: '{0} {1}'
        },
        lv: {
          end: '{0} un {1}',
          two: '{0} un {1}'
        },
        ms: {
          end: '{0} dan {1}',
          two: '{0} dan {1}'
        },
        pl: {
          end: '{0} i {1}',
          two: '{0} i {1}'
        },
        pt: {
          end: '{0} e {1}',
          two: '{0} e {1}'
        },
        ru: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} {1}',
          two: '{0} {1}'
        },
        sl: {
          end: '{0} in {1}',
          two: '{0} in {1}'
        },
        th: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} และ {1}',
          two: '{0} {1}'
        },
        tr: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} {1}',
          two: '{0} {1}'
        },
        uk: {
          end: '{0} і {1}',
          two: '{0} і {1}'
        },
        vi: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} {1}',
          two: '{0} {1}'
        },
        zh_cn: {
          start: '{0}{1}',
          middle: '{0}{1}',
          end: '{0}{1}',
          two: '{0}{1}'
        },
        zh_tw: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} {1}',
          two: '{0} {1}'
        }
      },
      conjunctionLong: {
        default: {
          start: '{0}, {1}',
          middle: '{0}, {1}',
          end: '{0}, and {1}',
          two: '{0} and {1}'
        },
        ar: {
          start: '{0}، و{1}',
          middle: '{0}، و{1}',
          end: '{0}، و{1}',
          two: '{0} و{1}'
        },
        bg: {
          end: '{0} и {1}',
          two: '{0} и {1}'
        },
        cs: {
          end: '{0} a {1}',
          two: '{0} a {1}'
        },
        da: {
          end: '{0} og {1}',
          two: '{0} og {1}'
        },
        de: {
          end: '{0} und {1}',
          two: '{0} und {1}'
        },
        es: {
          end: '{0} y {1}',
          two: '{0} y {1}'
        },
        et: {
          end: '{0} ja {1}',
          two: '{0} ja {1}'
        },
        fa: {
          start: '{0}،‏ {1}',
          middle: '{0}،‏ {1}',
          end: '{0}، و {1}',
          two: '{0} و {1}'
        },
        fi: {
          end: '{0} ja {1}',
          two: '{0} ja {1}'
        },
        fr: {
          end: '{0} et {1}',
          two: '{0} et {1}'
        },
        he: {
          end: '{0} ו{1}',
          two: '{0} ו{1}'
        },
        hi: {
          end: '{0}, और {1}',
          two: '{0} और {1}'
        },
        hr: {
          end: '{0} i {1}',
          two: '{0} i {1}'
        },
        hu: {
          end: '{0} és {1}',
          two: '{0} és {1}'
        },
        hy: {
          start: '{0}, {1}',
          middle: '{0}, {1}',
          end: '{0} և {1}',
          two: '{0} և {1}'
        },
        id: {
          end: '{0}, dan {1}',
          two: '{0} dan {1}'
        },
        it: {
          end: '{0} e {1}',
          two: '{0} e {1}'
        },
        ja: {
          start: '{0}、{1}',
          middle: '{0}、{1}',
          end: '{0}、{1}',
          two: '{0}、{1}'
        },
        ko: {
          end: '{0} 및 {1}',
          two: '{0} 및 {1}'
        },
        lt: {
          start: '{0}, {1}',
          middle: '{0}, {1}',
          end: '{0} ir {1}',
          two: '{0} ir {1}'
        },
        lv: {
          end: '{0} un {1}',
          two: '{0} un {1}'
        },
        ms: {
          end: '{0} dan {1}',
          two: '{0} dan {1}'
        },
        nl: {
          end: '{0} en {1}',
          two: '{0} en {1}'
        },
        pl: {
          end: '{0} i {1}',
          two: '{0} i {1}'
        },
        pt: {
          end: '{0} e {1}',
          two: '{0} e {1}'
        },
        ru: {
          end: '{0} и {1}',
          two: '{0} и {1}'
        },
        se: {
          end: '{0} ja {1}',
          two: '{0} ja {1}'
        },
        sk: {
          end: '{0} a {1}',
          two: '{0} a {1}'
        },
        sl: {
          end: '{0} in {1}',
          two: '{0} in {1}'
        },
        th: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} และ{1}',
          two: '{0}และ{1}'
        },
        tr: {
          end: '{0} ve {1}',
          two: '{0} ve {1}'
        },
        uk: {
          end: '{0} і {1}',
          two: '{0} і {1}'
        },
        vi: {
          end: '{0} và {1}',
          two: '{0} và {1}'
        },
        zh_cn: {
          start: '{0}、{1}',
          middle: '{0}、{1}',
          end: '{0}和{1}',
          two: '{0}和{1}'
        },
        zh_tw: {
          start: '{0}、{1}',
          middle: '{0}、{1}',
          end: '{0}和{1}',
          two: '{0}和{1}'
        }
      },
      conjunctionShort: {
        default: {
          start: '{0}, {1}',
          middle: '{0}, {1}',
          end: '{0}, & {1}',
          two: '{0} & {1}'
        },
        ar: {
          start: '{0} و{1}',
          middle: '{0} و{1}',
          end: '{0} و{1}',
          two: '{0} و{1}'
        },
        bg: {
          end: '{0} и {1}',
          two: '{0} и {1}'
        },
        cs: {
          end: '{0} a {1}',
          two: '{0} a {1}'
        },
        da: {
          end: '{0} og {1}',
          two: '{0} og {1}'
        },
        de: {
          end: '{0} und {1}',
          two: '{0} und {1}'
        },
        es: {
          end: '{0} y {1}',
          two: '{0} y {1}'
        },
        et: {
          end: '{0} ja {1}',
          two: '{0} ja {1}'
        },
        fa: {
          start: '{0}،‏ {1}',
          middle: '{0}،‏ {1}',
          end: '{0}، و {1}',
          two: '{0} و {1}'
        },
        fi: {
          end: '{0} ja {1}',
          two: '{0} ja {1}'
        },
        fr: {
          end: '{0} et {1}',
          two: '{0} et {1}'
        },
        he: {
          end: '{0} ו{1}',
          two: '{0} ו{1}'
        },
        hi: {
          end: '{0}, और {1}',
          two: '{0} और {1}'
        },
        hr: {
          end: '{0} i {1}',
          two: '{0} i {1}'
        },
        hu: {
          end: '{0} és {1}',
          two: '{0} és {1}'
        },
        hy: {
          start: '{0}, {1}',
          middle: '{0}, {1}',
          end: '{0} և {1}',
          two: '{0} և {1}'
        },
        id: {
          end: '{0}, dan {1}',
          two: '{0} dan {1}'
        },
        it: {
          end: '{0} e {1}',
          two: '{0} e {1}'
        },
        ja: {
          start: '{0}、{1}',
          middle: '{0}、{1}',
          end: '{0}、{1}',
          two: '{0}、{1}'
        },
        ko: {
          end: '{0} 및 {1}',
          two: '{0} 및 {1}'
        },
        lt: {
          start: '{0}, {1}',
          middle: '{0}, {1}',
          end: '{0} ir {1}',
          two: '{0} ir {1}'
        },
        lv: {
          end: '{0} un {1}',
          two: '{0} un {1}'
        },
        ms: {
          end: '{0} dan {1}',
          two: '{0} dan {1}'
        },
        nl: {
          end: '{0} en {1}',
          two: '{0} en {1}'
        },
        pl: {
          end: '{0} i {1}',
          two: '{0} i {1}'
        },
        pt: {
          end: '{0} e {1}',
          two: '{0} e {1}'
        },
        ru: {
          end: '{0} и {1}',
          two: '{0} и {1}'
        },
        se: {
          end: '{0} ja {1}',
          two: '{0} ja {1}'
        },
        sk: {
          end: '{0} a {1}',
          two: '{0} a {1}'
        },
        sl: {
          end: '{0} in {1}',
          two: '{0} in {1}'
        },
        th: {
          start: '{0} {1}',
          middle: '{0} {1}',
          end: '{0} และ{1}',
          two: '{0}และ{1}'
        },
        tr: {
          end: '{0} ve {1}',
          two: '{0} ve {1}'
        },
        uk: {
          end: '{0} і {1}',
          two: '{0} і {1}'
        },
        vi: {
          end: '{0} và {1}',
          two: '{0} và {1}'
        },
        zh_cn: {
          start: '{0}、{1}',
          middle: '{0}、{1}',
          end: '{0}和{1}',
          two: '{0}和{1}'
        },
        zh_tw: {
          start: '{0}、{1}',
          middle: '{0}、{1}',
          end: '{0}和{1}',
          two: '{0}和{1}'
        }
      }
    }

  };
  return LocalePolicyOption;
}));
